import { render } from "./VerifyEmailPage.vue?vue&type=template&id=c9def446&scoped=true"
import script from "./VerifyEmailPage.vue?vue&type=script&lang=js"
export * from "./VerifyEmailPage.vue?vue&type=script&lang=js"

import "./VerifyEmailPage.vue?vue&type=style&index=0&id=c9def446&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9def446"]])

export default __exports__